import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './BuildingIotDevice.scss';

import { setBuildingIotDevice, setBuildingParkingDayConfig } from '../../actions';
import commonConstant from '../../common/_commonConstant';

import {  
  HeaderSection,  
  AddButton,
  Card,
  Tooltip,
  Dropdown,
} from '../../helpers';


class BuildingIotDevice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'displayVehicleParkingFee': [null],
      'mainZone': ['-'],
      'zoneAmount': 1,
    };

    this.displayVehicleParkingFee = [createRef()];
    this.mainZone = [createRef()];
  }

  componentDidMount() {
    const { buildingIotDevice } = this.props;
    if (buildingIotDevice != null) {
      const listOfZone = buildingIotDevice.buildingIotDevices.filter((device) => device.deviceType === 'KIOSK_PARKING_GATE' && device.deviceLocation === 'IN');
      const initialDisplayVehicleParkingFee = [];
      const initialMainZone = [];
      this.displayVehicleParkingFee = [];
      this.mainZone = [];
      listOfZone.sort((a, b) => parseInt(a.devicePosition, 10) - parseInt(b.devicePosition, 10));
      for (let i = 0; i < listOfZone.length; i++) {
        if (listOfZone[i].mainZone === null) {
          initialMainZone.push('-');
        } else {
          initialMainZone.push(listOfZone[i].mainZone); 
        }

        initialDisplayVehicleParkingFee.push(commonConstant.displayVehicleParkingFee.filter((item) => item.value === listOfZone[i].vehicleDisplayType)[0]);

        this.displayVehicleParkingFee.push(createRef());
        this.mainZone.push(createRef());
      }
      this.setState({
        'displayVehicleParkingFee' : initialDisplayVehicleParkingFee,
        'mainZone' : initialMainZone,
        'zoneAmount' : listOfZone.length,
      });
    }
  }

  handleDispatchData = () => {
    const { displayVehicleParkingFee, mainZone, zoneAmount } = this.state;
    const { buildingParkingDayConfig } = this.props;
    const buildingIotDevices = [];
    const setBuildingParkingDayConfigWeekday = [];
    const setBuildingParkingDayConfigWeekend = [];

    for (let zoneIndex = 0; zoneIndex < zoneAmount; zoneIndex++) {
      const location = zoneIndex + 1 < 9 ? `0${zoneIndex + 1}` : `${zoneIndex + 1}`;
      buildingIotDevices.push(
        {
          'deviceType': 'KIOSK_PARKING_GATE',
          'deviceLocation': 'IN',
          'devicePosition': location,
          'mainZone': mainZone[zoneIndex] != '-' ? mainZone[zoneIndex] : null,
          'vehicleDisplayType': displayVehicleParkingFee[zoneIndex] ? displayVehicleParkingFee[zoneIndex].value : '',
        },
        {
          'deviceType': 'KIOSK_PARKING_GATE',
          'deviceLocation': 'OUT',
          'devicePosition': location,
          'mainZone': mainZone[zoneIndex] != '-' ? mainZone[zoneIndex] : null,
          'vehicleDisplayType': displayVehicleParkingFee[zoneIndex] ? displayVehicleParkingFee[zoneIndex].value : '',
        },
        {
          'deviceType': 'PARKING_GATE',
          'deviceLocation': 'IN',
          'devicePosition': location,
          'mainZone': mainZone[zoneIndex] != '-' ? mainZone[zoneIndex] : null,
          'vehicleDisplayType': '',
        },
        {
          'deviceType': 'PARKING_GATE',
          'deviceLocation': 'OUT',
          'devicePosition': location,
          'mainZone': mainZone[zoneIndex] != '-' ? mainZone[zoneIndex] : null,
          'vehicleDisplayType': '',
        },
        {
          'deviceType': 'LPR',
          'deviceLocation': 'IN',
          'devicePosition': location,
          'mainZone': mainZone[zoneIndex] != '-' ? mainZone[zoneIndex] : null,
          'vehicleDisplayType': '',
        },
        {
          'deviceType': 'LPR',
          'deviceLocation': 'OUT',
          'devicePosition': location,
          'mainZone': mainZone[zoneIndex] != '-' ? mainZone[zoneIndex] : null,
          'vehicleDisplayType': '',
        },
      );

      setBuildingParkingDayConfigWeekday.push(
        {
          'parkingDayConfigDayType': 'WEEKDAY',          
          'parkingDayConfigParkingZone': `IN-${location}/OUT-${location}`,
          'parkingDayConfigAllowance': null,
          'parkingDayConfigChargeCustomer': null,
          'parkingDayConfigStartDatetime' : null,
          'parkingDayConfigEndDatetime' : null,
        },
      );

      setBuildingParkingDayConfigWeekend.push(
        {
          'parkingDayConfigDayType': 'WEEKEND',          
          'parkingDayConfigParkingZone': `IN-${location}/OUT-${location}`,
          'parkingDayConfigAllowance': null,
          'parkingDayConfigChargeCustomer': null,
          'parkingDayConfigStartDatetime' : null,
          'parkingDayConfigEndDatetime' : null,
        },
      );
    }


    this.props.dispatch(setBuildingIotDevice(
      {
        'buildingIotDevices' : buildingIotDevices,
        'isCanSave' : !displayVehicleParkingFee.includes(null),
      },
    ));    

    if (buildingParkingDayConfig != null) {
      const weekdayParkingDayConfig = buildingParkingDayConfig.parkingDayConfig.filter((data) => data.parkingDayConfigDayType === 'WEEKDAY');
      weekdayParkingDayConfig.sort((a, b) => parseInt(a.parkingDayConfigParkingZone.split('-')[2], 10) - parseInt(b.parkingDayConfigParkingZone.split('-')[2], 10));
      const weekendParkingDayConfig = buildingParkingDayConfig.parkingDayConfig.filter((data) => data.parkingDayConfigDayType === 'WEEKEND');
      weekendParkingDayConfig.sort((a, b) => parseInt(a.parkingDayConfigParkingZone.split('-')[2], 10) - parseInt(b.parkingDayConfigParkingZone.split('-')[2], 10));
      const customParkingDayConfig = buildingParkingDayConfig.parkingDayConfig.filter((data) => data.parkingDayConfigDayType === 'CUSTOM');
      customParkingDayConfig.sort((a, b) => parseInt(a.parkingDayConfigParkingZone.split('-')[2], 10) - parseInt(b.parkingDayConfigParkingZone.split('-')[2], 10));
      const newWeekday = [];
      const newWeekend = [];
      for (let i = 0; i < setBuildingParkingDayConfigWeekday.length; i++) {
        const location = i + 1 < 9 ? `0${i + 1}` : `${i + 1}`;
        newWeekday.push(
          {
            'parkingDayConfigDayType': 'WEEKDAY',          
            'parkingDayConfigParkingZone': `IN-${location}/OUT-${location}`,
            'parkingDayConfigAllowance': weekdayParkingDayConfig[i] && weekdayParkingDayConfig[i].parkingDayConfigAllowance ? weekdayParkingDayConfig[i].parkingDayConfigAllowance : null,
            'parkingDayConfigChargeCustomer':weekdayParkingDayConfig[i] && weekdayParkingDayConfig[i].parkingDayConfigChargeCustomer ? weekdayParkingDayConfig[i].parkingDayConfigChargeCustomer : null,
            'parkingDayConfigStartDatetime' : null,
            'parkingDayConfigEndDatetime' : null,
          },
        );
      }
      for (let i = 0; i < setBuildingParkingDayConfigWeekend.length; i++) {
        const location = i + 1 < 9 ? `0${i + 1}` : `${i + 1}`;
        newWeekend.push(
          {
            'parkingDayConfigDayType': 'WEEKEND',          
            'parkingDayConfigParkingZone': `IN-${location}/OUT-${location}`,
            'parkingDayConfigAllowance': weekendParkingDayConfig[i] && weekendParkingDayConfig[i].parkingDayConfigAllowance ? weekendParkingDayConfig[i].parkingDayConfigAllowance : null,
            'parkingDayConfigChargeCustomer':weekendParkingDayConfig[i] && weekendParkingDayConfig[i].parkingDayConfigChargeCustomer ? weekendParkingDayConfig[i].parkingDayConfigChargeCustomer : null,
            'parkingDayConfigStartDatetime' : null,
            'parkingDayConfigEndDatetime' : null,
          },
        );
      }
      this.props.dispatch(setBuildingParkingDayConfig({
        'parkingDayConfig' : [
          ...newWeekday,
          ...newWeekend,
          ...customParkingDayConfig,
        ],
      }));
    } else {
      this.props.dispatch(setBuildingParkingDayConfig({
        'parkingDayConfig' : [
          ...setBuildingParkingDayConfigWeekday,
          ...setBuildingParkingDayConfigWeekend,          
        ],
      }));
    }
  }

  handleAddZone = () => {
    this.setState({
      'displayVehicleParkingFee' : [...this.state.displayVehicleParkingFee, null],
      'mainZone' : [...this.state.mainZone, '-'],
      'zoneAmount' : this.state.zoneAmount + 1,
    }, () => {this.handleDispatchData();});

    this.displayVehicleParkingFee.push(createRef());
    this.mainZone.push(createRef());
  }

  handleRemoveZone = (zoneIndex) => {
    const { displayVehicleParkingFee, mainZone, zoneAmount } = this.state;
    const removeZone = zoneIndex + 1 < 9 ? `0${zoneIndex + 1}` : `${zoneIndex + 1}`;
    const newDisplayVehicleParkingFee = [...displayVehicleParkingFee];
    const newZoneAmount = zoneAmount - 1;
    newDisplayVehicleParkingFee.splice(zoneIndex, 1);
    const newMainZone = [];    
    for (let i = 0; i < mainZone.length; i++) {
      if (mainZone[i] === removeZone){        
        newMainZone.push('-');
      } else {
        newMainZone.push(mainZone[i]);
      }
    }    
    newMainZone.splice(zoneIndex, 1);

    this.displayVehicleParkingFee.pop();
    this.mainZone.pop();

    this.setState({
      'displayVehicleParkingFee' : newDisplayVehicleParkingFee,
      'mainZone' : newMainZone,
      'zoneAmount' : newZoneAmount,
    }, () => {this.handleDispatchData();});
  }

  handleEventByIndex = (key, value, zoneIndex) => {
    const item = [...this.state[key]];
    item[zoneIndex] = value;
    this.setState({ [key]: item }, () => {this.handleDispatchData();});

    if (key === 'displayVehicleParkingFee') {
      this['displayVehicleParkingFee'][zoneIndex].current.handleShowItem();
    } else if (key === 'mainZone') {
      this['mainZone'][zoneIndex].current.handleShowItem();
    }
  }

  handleGenerateMainZoneDropdown = (zoneIndex) => {
    const { zoneAmount } = this.state;
    const listOfDropDown = [
      <div
        key={'dash'}
        className={`item${this.state['mainZone'][zoneIndex] && this.state['mainZone'][zoneIndex] === '-' ? ' active' : ''}`}
        onClick={() => this.handleEventByIndex('mainZone', '-', zoneIndex)}
      >{'-'}</div>,
    ];
    for (let i = 0; i < zoneAmount; i++) {
      if (zoneIndex !== i) {
        const mainZoneNumber = i < 9 ? `0${i + 1}` : `${i + 1}`;
        listOfDropDown.push(
          <div
            key={i}
            className={`item${this.state['mainZone'][zoneIndex] && this.state['mainZone'][zoneIndex] === mainZoneNumber ? ' active' : ''}`}
            onClick={() => this.handleEventByIndex('mainZone', mainZoneNumber, zoneIndex)}
          >{mainZoneNumber}</div>,
        );
      }
    }

    return listOfDropDown;
  }

  handleGenerateZone = () => {
    const zone = [];

    for (let zoneIndex = 0; zoneIndex < this.state.zoneAmount; zoneIndex++) {
      zone.push(
        <div key={zoneIndex} id={`zone-${zoneIndex}`} className="zone">
          <div className="zone-number-container">
            <div className="zone-number-label">
              <Tooltip tooltip="โซนที่จอดรถ">
                <span>Zone number</span>
              </Tooltip>                    
            </div>
            <div className="zone-number-input">
              <div>{zoneIndex < 9 ? `0${zoneIndex + 1}` : `${zoneIndex + 1}`}</div>
            </div>
          </div> 
          <div className="display-vehicle-parking-fee-container">
            <div className="display-vehicle-parking-fee-label">
                Display vehicle parking fee
            </div>
            <div className="display-vehicle-parking-fee-dropdown">
              <Dropdown
                template="b"
                placeholder="Parking fee type"
                value={this.state['displayVehicleParkingFee'][zoneIndex] && this.state['displayVehicleParkingFee'][zoneIndex].label ? this.state['displayVehicleParkingFee'][zoneIndex].label : null}
                ref={this['displayVehicleParkingFee'][zoneIndex]} >                
                {
                  commonConstant.displayVehicleParkingFee.map((ele, displayVehicleParkingFeeIndex) => (
                    <div
                      key={displayVehicleParkingFeeIndex}
                      className={`item${this.state['displayVehicleParkingFee'][zoneIndex] && this.state['displayVehicleParkingFee'][zoneIndex].value === ele.value ? ' active' : ''}`}
                      onClick={() => this.handleEventByIndex('displayVehicleParkingFee', ele, zoneIndex)}
                    >{ele.label}</div>
                  ))
                }                
              </Dropdown>
            </div>
          </div> 
          <div className="main-zone-container">
            <div className="main-zone-label">
              <Tooltip tooltip="โซนที่จอดรถ">
                <span>Main zone</span>
              </Tooltip>    
            </div>
            <div className="main-zone-dropdown-container">
              <div className="main-zone-dropdown">
                <Dropdown
                  template="b"
                  placeholder="Choose main zone"
                  value={this.state['mainZone'][zoneIndex] && this.state['mainZone'][zoneIndex] ? this.state['mainZone'][zoneIndex] : null}
                  ref={this['mainZone'][zoneIndex]} >                
                  {
                    this.handleGenerateMainZoneDropdown(zoneIndex)
                  }                
                </Dropdown>              
              </div>
              {
                zoneIndex > 0 ? 
                  <div className="icon fas fa-x" onClick={() => this.handleRemoveZone(zoneIndex)} /> 
                  : null
              } 
            </div>
          
           
          </div>  
                
        </div>,
      );
    }

    return zone;
  }

  render() {
    return (
      <div className="BuildingIotDevice">
        <HeaderSection title="Zone" >
          <AddButton text="Add zone" handleOnClick={() => this.handleAddZone()} />
        </HeaderSection>
        <div className="zone-container">
          <Card>
            <div className="zone-list-container">
              {this.handleGenerateZone()} 
            </div>           
          </Card>
        </div>

      </div>
    );
  }
}

const mapStateToProps = ({ buildingIotDevice, buildingParkingDayConfig }) => ({
  'buildingIotDevice' : buildingIotDevice.data,
  'buildingParkingDayConfig' : buildingParkingDayConfig.data,
});

export default connect(mapStateToProps)(BuildingIotDevice);

BuildingIotDevice.propTypes = {
  'dispatch' : PropTypes.func,
  'buildingIotDevice' : PropTypes.shape({
    'buildingIotDevices' : PropTypes.array,    
    'isCanSave' : PropTypes.bool,
  }),
  'buildingParkingDayConfig' : PropTypes.shape({
    'parkingDayConfig' :PropTypes.arrayOf(
      PropTypes.shape({          
        'parkingDayConfigDayType': PropTypes.string,        
        'parkingDayConfigParkingZone': PropTypes.string,
        'parkingDayConfigAllowance': PropTypes.string,
        'parkingDayConfigChargeCustomer': PropTypes.string,
        'parkingDayConfigStartDatetime': PropTypes.string,
        'parkingDayConfigEndDatetime': PropTypes.string,
      }),
    ),
  }),
};
